import { Dispatch, SetStateAction } from "react";
import { Link } from "react-router-dom";
import { IPages, IPlan } from "..";
import Button from "../../../components/Button";

export const Plans = ({ setPlan, setPage }: { setPlan: Dispatch<SetStateAction<IPlan>>; setPage: Dispatch<SetStateAction<IPages>> }) => {
  return (
    <div className="box-form flex flex-col justify-around items-center mt-8 gap-6 p-8">
      <div className="flex">
        <p className="text-4xl"> Escolha um plano para sua conta</p>
      </div>
      <div className="flex flex-row items-center justify-around w-full gap-20">
        <MonthPlan setPlan={setPlan} setPage={setPage} />
        <YearPlan setPlan={setPlan} setPage={setPage} />
      </div>
      <div className="flex flex-col items-center">
        <p className="mb-3 ">Caso tenha dúvida em relação ao valor, faça o simulado clicando abaixo.</p>
        <Link to={"/prices"} className="text-primary" target="_blank">
          <Button className="w-auto bg-primary">Faça o simulado</Button>
        </Link>
      </div>
    </div>
  );
};

export const MonthPlan = ({
  setPlan,
  setPage,
  button = true,
}: {
  setPlan: Dispatch<SetStateAction<IPlan>>;
  setPage: Dispatch<SetStateAction<IPages>>;
  button?: boolean;
}) => {
  return (
    <>
      <div className="h-auto p-4 w-full flex flex-col justify-center items-center rounded-xl bg-blue-100 border-2 border-primary text-primary gap-5">
        <p>Mensal</p>
        <ul className="w-full flex flex-col gap-4">
          <div className="flex flex-row justify-between text-2xl border-b border-black">
            <span>Até 5 Usuarios</span>
            <div>
              <span className="font-semibold">R$ 11,99</span>
              <span className="text-lg ml-2">por usuário</span>
            </div>
          </div>
          <div className="flex flex-row justify-between text-2xl border-b border-black">
            <span>De 5 até 10 Usuarios</span>
            <div>
              <span className="font-semibold">R$ 10,99</span>
              <span className="text-lg ml-2">por usuário</span>
            </div>
          </div>
          <div className="flex flex-row justify-between text-2xl border-b border-black">
            <span>De 11 até 20 Usuarios</span>
            <div>
              <span className="font-semibold">R$ 8,99</span>
              <span className="text-lg ml-2">por usuário</span>
            </div>
          </div>
          <div className="flex flex-row justify-between text-2xl border-b border-black">
            <span>De 21 até 50 Usuarios</span>
            <div>
              <span className="font-semibold">R$ 7,99</span>
              <span className="text-lg ml-2">por usuário</span>
            </div>
          </div>
          <div className="flex flex-row justify-between text-2xl border-b border-black">
            <span>Apartir de 51 Usuarios</span>
            <div>
              <span className="font-semibold">R$ 6,99</span>
              <span className="text-lg ml-2">por usuário</span>
            </div>
          </div>
        </ul>
        {button ? (
          <Button
            onClick={() => {
              setPage("DataPersonal");
              setPlan("Month");
            }}
            className="bg-primary"
          >
            Quero este
          </Button>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export const YearPlan = ({
  setPlan,
  setPage,
  button = true,
}: {
  setPlan: Dispatch<SetStateAction<IPlan>>;
  setPage: Dispatch<SetStateAction<IPages>>;
  button?: boolean;
}) => {
  return (
    <div className="h-auto p-4 w-full flex flex-col justify-center items-center rounded-xl bg-primary gap-5">
      <p>Anual</p>
      <ul className="w-full flex flex-col gap-4">
        <div className="flex flex-row justify-between text-2xl border-b border-blue-100">
          <span>Até 5 Usuarios</span>
          <div>
            <span className="font-semibold">R$ 9,99</span>
            <span className="text-lg ml-2">por usuário</span>
          </div>
        </div>
        <div className="flex flex-row justify-between text-2xl border-b border-blue-100">
          <span>De 5 até 10 Usuarios</span>
          <div>
            <span className="font-semibold">R$ 8,99</span>
            <span className="text-lg ml-2">por usuário</span>
          </div>
        </div>
        <div className="flex flex-row justify-between text-2xl border-b border-blue-100">
          <span>De 11 até 20 Usuarios</span>
          <div>
            <span className="font-semibold">R$ 6,99</span>
            <span className="text-lg ml-2">por usuário</span>
          </div>
        </div>
        <div className="flex flex-row justify-between text-2xl border-b border-blue-100">
          <span>De 21 até 50 Usuarios</span>
          <div>
            <span className="font-semibold">R$ 5,99</span>
            <span className="text-lg ml-2">por usuário</span>
          </div>
        </div>
        <div className="flex flex-row justify-between text-2xl border-b border-blue-100">
          <span>Apartir de 51 Usuarios</span>
          <div>
            <span className="font-semibold">R$ 4,99</span>
            <span className="text-lg ml-2">por usuário</span>
          </div>
        </div>
      </ul>
      {button ? (
        <Button
          onClick={() => {
            setPage("DataPersonal");
            setPlan("Year");
          }}
          className="bg-blue-100 border border-primary text-primary"
        >
          Quero este
        </Button>
      ) : (
        ""
      )}
    </div>
  );
};
